import styled from "styled-components"
import {Card} from "@malwarebytes/react-components/build"

export const BorderlessCard = styled(Card)`
  border-radius: 0!important;
  border: none!important;
`
